// Should a query error REPLACE the page/component content with an error state?
//
// Only when there's nothing cached to fall back on. A failed BACKGROUND refetch
// in TanStack Query v5 retains the previously-resolved `data` while populating
// `error` (isLoading stays false). If a render guard checks `error` before
// cached `data`, a momentary blip blanks a page that still has perfectly good
// content. So: show the error state ONLY when the error coincides with no data.
//
// Sibling precedent: auth-gate.ts (same RQ-v5 retention behavior, app root).
// NOTE: `hasData` must reflect the SAME query's cached data. With
// placeholderData/keepPreviousData, `data` stays populated, so this still holds.
export const isBlockingError = (error: unknown, hasData: boolean): boolean =>
  !!error && !hasData;
